import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button, ProgressBar, Card, Modal, Alert, Nav, Spinner, Dropdown, FormControl, Stack } from 'react-bootstrap';
import { useOutletContext, useNavigate, useLocation } from 'react-router-dom';
//import spinnerIcon from './/./../assets/img/loadingSpinner.gif'
import PaginationComponent from '../components/pagination/PaginationComponent.js'
import SpinnerComponent from '../components/progressbar/SpinnerComponent.js'
import { useAuth0 } from "@auth0/auth0-react";
import { apiGet, apiPut } from "../services/AuthService.js";
import { useSessionState } from "../lib/useSessionState.js";
import {
    btnGold, btnGoldHover, FOCUS_GOLD, COLORS,
    header, footer, goldLinkBase, addUnderline, removeUnderline,
    boxshadowHover, boxshadowUnHover,
    showAdvancedBtn, searchBtn, uploadBtn, resetFiltersBtn, sourceDataBtn,
    statusColors, darkStatusColors,
    formLabel, columnTitle, columnSortLink, goldInputFocus, statusLabel,
    frame, goldFaPlus, faIconStyle,
    inputSm, paginationStyle, activePaginationStyle,
    dropDownToggle, dropDownInput, dropDownMenu, tableRowHover, tableRowUnHover, stickyThStyle,
    filterActiveIndicator, btnRed
} from '../styles/goldTheme.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass, faArrowUpLong, faArrowDownLong } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'

//TBD: see if changing to match pagination component pattern fixes errors
function MappingsModal(props) {
    const { handlemapbutton, datafile } = props

    return (
        <Modal
            {...props}    
            handlemapbutton
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>Mappings</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>Specify the mappings below for this file:</h6>
                
                <Container>

                {(() => {
                    if (!datafile.ownersMapped) {
                        return <Row style={{ marginTop: '40px' }} >
                            <Col xs={3} >
                                Owner Mappings:
                            </Col>
                            <Col xs={9} >
                                <Button
                                    type='button'
                                    size='sm'
                                    style={{
                                        ...btnGold,
                                        width: '200px'
                                    }}
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                    disabled={false}
                                    onClick={() => handlemapbutton('owners')}
                                >
                                    Map Owners
                                </Button>
                            </Col>
                        </Row>                        
                    }
                })()}
                
                {(() => {
                    if (!datafile.cdexCodesMapped) {
                        return <Row style={{marginTop: '20px'}} >
                            <Col xs={3} >
                                CDEX Code Mappings:
                            </Col>
                            <Col xs={9} >
                                <Button
                                    type='button'
                                    size='sm'
                                    style={{
                                        ...btnGold,
                                        width: '200px'
                                    }}
                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                    disabled={false}
                                    onClick={() => handlemapbutton('cdexCodes')}
                                >
                                    Map CDEX Codes
                                </Button>
                            </Col>
                        </Row>

                        
                    }
                    })()}

                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    style={{
                        ...btnGold,
                    }}
                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                    onClick={props.onHide}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
function JibMappingsModal(props) {
    const { handlemapbutton, datafile } = props

    return (
        <Modal
            {...props}    
            handlemapbutton
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>Mappings</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>Specify the mappings below for this file:</h6>
                
                <Container>

                {(() => {
                    if (!datafile.ownersMapped) {
                        return <Row style={{ marginTop: '40px' }} >
                            <Col xs={3} >
                                Owner Mappings:
                            </Col>
                            <Col xs={9} >
                                <Button
                                    type='button'
                                    size='sm'
                                    style={{
                                        ...btnGold,
                                        width: '200px'
                                    }}
                                    disabled={false}
                                    onClick={() => handlemapbutton('owners')}
                                >
                                    Map Owners
                                </Button>
                            </Col>
                        </Row>                        
                    }
                })()}
                
                {(() => {
                      //if (true) {
                      if (!datafile.cdexCodesMapped) {
                        return <Row style={{marginTop: '20px'}} >
                            <Col xs={3} >
                                JIB Classification Mappings:
                            </Col>
                            <Col xs={9} >
                                <Button
                                    type='button'
                                    size='sm'
                                    style={{
                                        ...btnGold,
                                        width: '200px'
                                    }}
                                    disabled={false}
                                    onClick={() => handlemapbutton('classificationCodes')}
                                >
                                    Map Classification Codes
                                </Button>
                            </Col>
                        </Row>

                        
                    }
                    })()}

                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    style={{
                        ...btnGold,
                    }}
                    onClick={props.onHide}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
function Ten99MappingsModal(props) {
    const { handlemapbutton, datafile } = props

    return (
        <Modal
            {...props}    
            handlemapbutton
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>Mappings</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>Specify the mappings below for this file:</h6>
                
                <Container>

                {(() => {
                    if (!datafile.ownersMapped) {
                        return <Row style={{ marginTop: '40px' }} >
                            <Col xs={3} >
                                Owner Mappings:
                            </Col>
                            <Col xs={9} >
                                <Button
                                    type='button'
                                    size='sm'
                                    style={{
                                        ...btnGold,
                                        width: '200px'
                                    }}
                                    disabled={false}
                                    onClick={() => handlemapbutton('owners')}
                                >
                                    Map Owners
                                </Button>
                            </Col>
                        </Row>                        
                    }
                })()}

                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    style={{
                        ...btnGold,
                    }}
                    onClick={props.onHide}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

function formatCheckDate(checkDateString, fileTypeId) {
    if (!checkDateString) return "";

    const parts = checkDateString.split("/");
    if (parts.length !== 3) return checkDateString;

    const m = parts[0];
    const d = parts[1];
    const y = parts[2];
    
    if (fileTypeId === '2') return `${m}/${y}`; 
    if (fileTypeId === '4') return `${y}`;   
    return `${m}/${d}/${y}`;     
}

function ClickToSendConfirmationModal(props) {
    const { onConfirm, dataFile, fileTypeId, ...modalProps } = props;
    const checkDateDisplay = formatCheckDate(dataFile?.checkDateString, fileTypeId);

    return (
        <Modal
            {...modalProps}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <h4>Confirm To Send</h4>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Container style={{ height: "80px" }}>
                    <Row>
                        <Col style={{ display: "flex", justifyContent: "center", textAlign: "center", marginBottom: "-10px" }}>
                            <p>Please confirm the release of your statements:</p>
                        </Col>
                    </Row>
                    {dataFile && (
                        <Row>
                            <Col style={{ textAlign: "center" }}>
                                <small>
                                    {dataFile.description} - {checkDateDisplay}
                                </small>
                            </Col>
                        </Row>
                    )}
                </Container>
            </Modal.Body>

            <Modal.Footer>
                <Container>
                    <Row>
                        <Col style={{ display: "flex", justifyContent: "left" }}>
                            <Button
                                style={{ ...btnRed }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnRed))}
                                onClick={props.onHide}
                            >
                                Cancel
                            </Button>
                        </Col>
                        <Col style={{ display: "flex", justifyContent: "right" }}>
                            <Button
                                style={{ ...btnGold }}
                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                onClick={onConfirm}
                            >
                                Confirm
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Modal.Footer>
        </Modal>
    );
}

const DataFiles = props => {

    //properties
    const baseUrl = process.env.REACT_APP_API_BASEURL;
    const { getAccessTokenSilently } = useAuth0();

    //stateful properties (hooks)
    const navigate = useNavigate();
    const [currentAccount, accountProfile, setAccountProfile, toggleIsShowSidebarMd, setIsShowSidebarMd] = useOutletContext();
    const [pageStatus, setPageStatus] = useState('ready');
    const [dataStatus, setDataStatus] = useState('');
    const [pageErrors, setPageErrors] = useState('');
    const [dataErrors, setDataErrors] = useState('');
    const [displayResultGrid, setDisplayResultGrid] = useState(true);
    const [operators, setOperators] = useState([]);
    const [fileTypes, setFileTypes] = useState(['Select File Type...', 'Revenue', 'JIB', 'Plant', '1099']);
    const [dataFiles, setDataFiles] = useState([]);
    const [selectedDataFile, setSelectedDataFile] = useState([]);
    const [years, setYears] = useState([]);
    const [months, setMonths] = useState([]);
    const [statusItems, setStatusItems] = useState(['', 'File Load Processing', 'Mapping Needed', 'Ready to Send', 'Sent']);
    //Filter state persisted to sessionStorage so navigating away and back
    //restores the user's filters. skipCount is reset to 0 on restore (page
    //starts back at 1, but the filter values come back). The key is scoped by
    //currentAccount.id so each account has its own slot — switching accounts
    //(either via the admin switcher or by logging in as a different user) no
    //longer leaks the previous account's filters into the next one.
    const resetSkipCount = (loaded) => ({ ...loaded, skipCount: 0 });
    const acctKey = currentAccount?.id ?? 'none';
    const [dataCriteria, setDataCriteria] = useSessionState(`DataFiles.dataCriteria.${acctKey}`, {
        skipCount: 0,
        takeCount: 50,
        operatorId: 0,
        fromMonth: '',
        fromYear: '',
        toMonth: '',
        toYear: '',
        statusId: 0
    }, resetSkipCount);
    const [jibDataCriteria, setJibDataCriteria] = useSessionState(`DataFiles.jibDataCriteria.${acctKey}`, {
        skipCount: 0,
        takeCount: 50,
        operatorId: 0,
        fromMonth: '',
        fromYear: '',
        toMonth: '',
        toYear: '',
        statusId: 0
    }, resetSkipCount);
    const [ten99DataCriteria, setTen99DataCriteria] = useSessionState(`DataFiles.ten99DataCriteria.${acctKey}`, {
        skipCount: 0,
        takeCount: 50,
        operatorId: 0,
        fromYear: '',
        toYear: '',
        statusId: 0
    }, resetSkipCount);
    const [fileTypeCriteria, setFileTypeCriteria] = useSessionState(`DataFiles.fileTypeCriteria.${acctKey}`, { fileTypeId: '1' });
    const location = useLocation(); //for re-routing from import.js

    const [hydrated, setHydrated] = useState(false);

    const [rowCount, setRowCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [screenHeight, setScreenHeight] = useState(100);

    const [modalShow, setModalShow] = React.useState(false);
    const [jibMapModalShow, setJibMapModalShow] = React.useState(false);
    const [ten99MapModalShow, setTen99MapModalShow] = React.useState(false);
    const [clickToSendConfirmationModalShow, setClickToSendConfirmationModalShow] = useState(false);

    const [pendingAction, setPendingAction] = useState(null);

    const [alertShow, setAlertShow] = React.useState(false);
    const [alertVariant, setAlertVariant] = React.useState('success');
    const [alertMessage, setAlertMessage] = React.useState('Statements sent successfully!');

    const [hoveredBtn, setHoveredBtn] = useState(null);

    const CRITERIA_BY_TYPE = {
        '1': dataCriteria,
        '2': jibDataCriteria,
        '4': ten99DataCriteria,
    };

    const SETTER_BY_TYPE = {
        '1': setDataCriteria,
        '2': setJibDataCriteria,
        '4': setTen99DataCriteria,
    };

    const activeCriteria = CRITERIA_BY_TYPE[fileTypeCriteria.fileTypeId] || dataCriteria;
    const [searchVersion, setSearchVersion] = useState(0);
    const [sortDirection, setSortDirection] = useSessionState(`DataFiles.sortDirection.${acctKey}`, 'Descending');

    const toggleStatusDateSort = () => {
        setSortDirection(prev => prev === 'Descending' ? 'Ascending' : 'Descending');
        setSearchVersion(v => v + 1);
    };

    const isJibEnabled = (baseUrl && (baseUrl.includes("local") || baseUrl.includes("dev") || baseUrl.includes("qa") || baseUrl.includes("totdata-api.azurewebsites.net")));
    const is1099Enabled = (baseUrl && (baseUrl.includes("local") || baseUrl.includes("dev") || baseUrl.includes("qa") || baseUrl.includes("totdata-api.azurewebsites.net")));

    //initialize page
    useEffect(() => {
        (async () => {
            console.log('Initializing page...');

            if (setIsShowSidebarMd)
                setIsShowSidebarMd(true);

            //for re-routing from import.js
            if (location.state?.fileTypeId) {
                setFileTypeCriteria({ fileTypeId: location.state.fileTypeId });
            }

            //get inner browser window height
            const height = window.innerHeight;
            setScreenHeight(height);

            await initializeForm()
                .then(response => {
                    setOperators(response.data);
                    setYears(response.dates.years);
                    setMonths(response.dates.months);
                    //Use the previous (possibly sessionStorage-restored) value when
                    //it's non-default; otherwise fall back to the API defaults so
                    //first-time visitors still see something sensible.
                    setDataCriteria(prev => ({
                        ...prev,
                        operatorId: prev.operatorId || response.data[0].id,
                        fromMonth: prev.fromMonth || response.dates.fromMonth,
                        fromYear: prev.fromYear || response.dates.fromYear,
                        toMonth: prev.toMonth || response.dates.currMonth,
                        toYear: prev.toYear || response.dates.currYear,
                        takeCount: prev.takeCount || 50,
                        skipCount: 0
                    }));

                    setJibDataCriteria(prev => ({
                        ...prev,
                        operatorId: prev.operatorId || response.data[0].id,
                        fromMonth: prev.fromMonth || response.dates.fromMonth,
                        fromYear: prev.fromYear || response.dates.fromYear,
                        toMonth: prev.toMonth || response.dates.currMonth,
                        toYear: prev.toYear || response.dates.currYear,
                        takeCount: prev.takeCount || 50,
                        skipCount: 0
                    }));

                    setTen99DataCriteria(prev => ({
                        ...prev,
                        operatorId: prev.operatorId || response.data[0].id,
                        fromYear: prev.fromYear || response.dates.fromYear,
                        toYear: prev.toYear || response.dates.currYear,
                        takeCount: prev.takeCount || 50,
                        skipCount: 0
                    }));

                    let currentCriteria = {
                        skipCount: 0,
                        takeCount: 50,
                        operatorId: response.data[0].id,
                        fromMonth: response.dates.fromMonth,
                        fromYear: response.dates.fromYear,
                        toMonth: response.dates.currMonth,
                        toYear: response.dates.currYear,
                        statusId: 0
                    };

                    //restore active tab from local storage (criteria intentionally not restored).
                    //an explicit fileTypeId passed in through navigation - eg. landing here straight
                    //after an import - is the most recent intent, so it wins over the saved tab.
                    const sessionDataStr = location.state?.fileTypeId ? null : localStorage.getItem('dataFileState');

                    if (sessionDataStr) {
                        try {
                            const s = JSON.parse(sessionDataStr);

                            if (s.fileTypeId) {
                                setFileTypeCriteria({ fileTypeId: String(s.fileTypeId) });
                            }
                        } catch (e) {
                            console.warn('Bad dataFileState in localStorage:', e);
                        }
                    }

                    setHydrated(true);
                })
                .catch(ex => {
                    setPageStatus('error');
                    setPageErrors(ex.message);
                })
                .finally(response => {
                    //do something
                })
        })();
    }, [location.state]);

    useEffect(() => {
        if (!hydrated) return;

        let cancelled = false;

        const ft = fileTypeCriteria.fileTypeId;
        const criteria = CRITERIA_BY_TYPE[ft] || dataCriteria;

        setDataStatus("loading");
        setDataFiles([]);

        (async () => {
            try {
                const response = await populateDataFilesInitial(
                    { ...activeCriteria, skipCount: 0 },
                    fileTypeCriteria.fileTypeId
                );

                if (cancelled) return;

                if (!response.data || response.data.length === 0) {
                    setRowCount(0);
                    setDataFiles([]);
                    setDataStatus("nodata");
                } else {
                    setRowCount(response.data[0]?.rowCount || 0);
                    setDataFiles(response.data);
                    setDataStatus("ready");
                }
            } catch (ex) {
                if (cancelled) return;
                setDataStatus("error");
                setDataErrors(ex.message);
            }
        })();

        return () => {
            cancelled = true;
        }
    }, [fileTypeCriteria.fileTypeId, hydrated, searchVersion]);

    //persist active tab across navigation
    useEffect(() => {
        if (!hydrated) return;

        const payload = {
            fileTypeId: fileTypeCriteria.fileTypeId
        };

        try {
            localStorage.setItem('dataFileState', JSON.stringify(payload));
        } catch (e) {
            console.warn('Failed to save dataFileState:', e);
        }
    }, [fileTypeCriteria.fileTypeId, hydrated]);

    //initialize form
    const initializeForm = async () => {
        //TODO: might just call populateOperators() from useEffect
        //console.log('Initializing form...');

        //DEBUG: Adding a delay
        //await new Promise(r => setTimeout(r, 1200));

        //get dates for to/from dropdowns
        let dates = await getDates();

        //get operators for dropdown
        let operators = await getOperators();
        
        return { success: true, data: operators.data, dates: dates };

        //TODO: might want to clean this up with .then /.catch, but how to do with multiple api calls?
        //.then(get other data)
        //.catch(ex => throw...)
    };

    const getDates = () => {

        const date = new Date();
        //const day = date.getDate();
        const currMonth = date.getMonth() + 1;
        const currYear = date.getFullYear();

        //const fromMonth = currMonth === 1 ? 12 : currMonth - 2;
        //const fromYear = currMonth === 1 ? currYear - 1 : currYear;
        const fromMonth = currMonth > 6 ? currMonth - 6 : currMonth + 6;
        const fromYear = currMonth > 6 ? currYear : currYear - 1;

        const years = [currYear - 3, currYear - 2, currYear - 1, currYear, currYear + 1];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        return { months: months, years: years, currMonth: currMonth, currYear: currYear, fromMonth: fromMonth, fromYear: fromYear };
    };

    //get operators
    const getOperators = async () => {
        //console.log('Getting Operators...');

        console.log('AccountId: ' + currentAccount.id);

        const apiUrl = 'accounts/' + currentAccount.id + '/managedsenders';
        //console.log(apiUrl);

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    //fields that auto-trigger a search when changed (text inputs deliberately excluded)
    const AUTO_SEARCH_FIELDS = ['operatorId', 'statusId', 'fromMonth', 'fromYear', 'toMonth', 'toYear'];

    //handle form control changes
    const handleChange = (event, fileTypeId = fileTypeCriteria.fileTypeId) => {
        event.preventDefault();

        const fieldName = event.target.name;
        const value = event.target.value;
        console.log('Field: ' + fieldName + ', Value: ' + value);

        if (fileTypeId === "1") {
            setDataCriteria({
                ...dataCriteria,
                [fieldName]: value
            });
        } else if (fileTypeId === "2") {
            setJibDataCriteria({
                ...jibDataCriteria,
                [fieldName]: value
            });
        } else if (fileTypeId === "4") {
            setTen99DataCriteria({
                ...ten99DataCriteria,
                [fieldName]: value
            });
        }

        if (AUTO_SEARCH_FIELDS.includes(fieldName)) {
            setCurrentPage(1);
            setSearchVersion(v => v + 1);
        }
    }

    const handleTabSelect = (eventKey) => {
        if (!eventKey || eventKey === fileTypeCriteria.fileTypeId) return;
        setFileTypeCriteria({ fileTypeId: String(eventKey) });
        setCurrentPage(1);
    };

    //handle form submit
    const submitForm = async (e) => {
        e.preventDefault();

        setDataStatus('loading');
        setCurrentPage(1);

        setSearchVersion(v => v + 1);
    };

    //handle data file status changes
    const handleStatusChange = async (dataFileId, currentStatusId, arrayIndex) => {

        const newStatusId = currentStatusId + 1;
        //alert('Status Change: ' + e.target.name + ' for ' + dataFileId + ' at index ' + arrayIndex + ' from ' + currentStatusId + ' to ' + newStatusId);

        await updateDataFileStatus(dataFileId, newStatusId)
            .then(response => {
                if (response.success) {
                    //https://stackoverflow.com/questions/29537299/how-can-i-update-state-item1-in-state-using-setstate
                    let dFiles = [...dataFiles];
                    let dFile = { ...dFiles[arrayIndex] };
                    dFile.statusId = newStatusId;
                    dFiles[arrayIndex] = dFile;
                    setDataFiles(dFiles);

                    setAlertMessage("Statements sent successfully!");
                    setAlertShow(true);
                    setAlertVariant('success');
                }
                else {
                    setAlertMessage("Send failed.");
                    setAlertShow(true);
                    setAlertVariant('danger');
                }
            })
            .catch(ex => {
                setDataStatus('error');
                setDataErrors(ex.message);
            })
            .finally(response => {
                setTimeout(() => {
                    setAlertShow(false);
                }, 5000);
            })
    };

    //update datafile status
    const updateDataFileStatus = async (dataFileId, newStatusId) => {
        console.log('Updating DataFile Status...');

        const apiUrl = 'datafiles/' + dataFileId + '/status';
        const jsonBody = JSON.stringify({ id: dataFileId, statusId: newStatusId });
        //console.log(apiUrl);
        //console.log(jsonBody);

        const response = await apiPut(apiUrl, jsonBody, getAccessTokenSilently);

        return { success: response.ok, statusId: newStatusId };
    };

    const latestRequestRef = useRef(0);

    //handle page click
    const handlePageClick = async (page) => {
        console.log('Current Page: ' + page);

        setDataStatus('loading');
        setCurrentPage(page);

        const take = activeCriteria.takeCount || 50;
        const skipCount = page === 1 ? 0 : (page - 1) * take;
        const nextCriteria = { ...activeCriteria, skipCount: skipCount };

        const setCriteria = SETTER_BY_TYPE[fileTypeCriteria.fileTypeId] || setDataCriteria;
        setCriteria(nextCriteria);

        const requestId = ++latestRequestRef.current;

        //if (hydrated) {
        //    const sessionData = {
        //        fileTypeId: fileTypeCriteria.fileTypeId,
        //        activeCriteria: nextCriteria,
        //        currentPage: page
        //    };
        //    localStorage.setItem('dataFileState', JSON.stringify(sessionData));
        //}

        try {
            const response = await populateDataFilesInitial(
                nextCriteria,
                fileTypeCriteria.fileTypeId
            );

            if (latestRequestRef.current !== requestId) {
                return;
            }

            if (!response.data || response.data.length === 0) {
                setDataFiles([]);
                setDataStatus('nodata');
            } else {
                setDataFiles(response.data);
                setDataStatus('ready');
            }
        } catch (ex) {
            if (latestRequestRef.current !== requestId) return;
            setDataStatus('error');
            setDataErrors(ex.message);
        }
    };


    //populate datafiles
    const populateDataFilesInitial = async (currentCriteria, fileTypeId) => {
        //console.log('Getting DataFiles...');
        let apiUrl;

        if (String(fileTypeId) === '4') {
            apiUrl =
                'operators/' + currentCriteria.operatorId +
                '/datafiles?skipCount=' + currentCriteria.skipCount +
                '&takeCount=' + currentCriteria.takeCount +
                '&fromYear=' + currentCriteria.fromYear +
                '&toYear=' + currentCriteria.toYear +
                '&statusId=' + currentCriteria.statusId +
                '&statementTypeId=' + fileTypeId +
                '&sortDirection=' + sortDirection;
        } else {
            apiUrl =
                'operators/' + currentCriteria.operatorId +
                '/datafiles?skipCount=' + currentCriteria.skipCount +
                '&takeCount=' + currentCriteria.takeCount +
                '&fromMonth=' + currentCriteria.fromMonth +
                '&fromYear=' + currentCriteria.fromYear +
                '&toMonth=' + currentCriteria.toMonth +
                '&toYear=' + currentCriteria.toYear +
                '&statusId=' + currentCriteria.statusId +
                '&statementTypeId=' + fileTypeId +
                '&sortDirection=' + sortDirection;
        }

        const response = await apiGet(apiUrl, getAccessTokenSilently);
        const json = await response.json()
        console.log('Response - Status: ' + response.status + ', Success: ' + response.ok + ', Json: ' + JSON.stringify(json));

        return { success: response.ok, data: json };
    };

    //handle mappings button
    const handleMappingsButton = async (e, dataFile) => {
        e.preventDefault();

        console.log('Owners Mapped: ' + dataFile.ownersMapped);
        console.log('Cdex Codes Mapped: ' + dataFile.cdexCodesMapped);

        setDataStatus('loading');

        setSelectedDataFile(dataFile);
        setModalShow(true)

        setDataStatus('ready')
    };

    //handle mappings button
    const handleJIBMappingsButton = async (e, dataFile) => {
        e.preventDefault();

        setDataStatus('loading');
        //uncomment after TESTing and add dataFile in parameter
        setSelectedDataFile(dataFile);
        setJibMapModalShow(true);

        setDataStatus('ready')
    };

    //handle mappings button
    const handleTen99MappingsButton = async (e, dataFile) => {
        e.preventDefault();

        setDataStatus('loading');
        //uncomment after TESTing and add dataFile in parameter
        setSelectedDataFile(dataFile);
        setTen99MapModalShow(true);

        setDataStatus('ready')
    };

    const mappingButtonClick = (mappingType) => {

        console.log('Mapping Type: ' + mappingType);
        switch (mappingType) {
            case 'owners':
                //navigate('/mappings/' + selectedDataFile.id);
                navigate('/mappings/' + selectedDataFile.id, {
                    state: { fileTypeId: fileTypeCriteria.fileTypeId }
                });
                break;
            case 'cdexCodes':
                navigate('/unmappedcdex/' + selectedDataFile.id);
                break;
            case 'classificationCodes':
                navigate('/unmappedclassification/' + selectedDataFile.id);
                break;
            default:
            //do nothing
        }
    };

    function yearFrom(dateLike) {
        if (!dateLike) return "";

        var d = new Date(dateLike);
        if (!isNaN(d)) return String(d.getFullYear());

        var m = String(dateLike).match(/\b(19|20)\d{2}\b/);
        return m ? m[0] : "";
    }

    //function getTen99VersionName(version) {
    //    //if (version) {
    //    //    return version === 'O' ? 'Original' : 'Revised';
    //    //} else {
    //    //    return "";
    //    //}

    //    switch (version){
    //        case ('O'):
    //            return 'Original';
    //        case ('G'):
    //            return 'Revision';
    //        case ('C'):
    //            return 'Revision';
    //        default:
    //            return "";
    //    }
    //}

    //render page loading
    //note: spinner overlay will eventually be at the page level (I think)
    const showPageLoading = () => {
        return (
            <div>
                <Spinner
                    animation="border"
                    style={{ width: '3rem', height: '3rem', marginBottom: '1rem', color: COLORS.gold }}
                />
            </div>
        );
    }

    //render page loading
    const showDataLoading = () => {
        return (
            <div
                style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}
            >
                <Spinner
                    animation="border"
                    role="status"
                    style={{
                        width: '5rem',
                        height: '5rem',
                        borderWidth: '0.5rem',
                        color: COLORS.gold
                    }}
                />
                <div style={{ marginTop: '12px', color: '#6c757d', fontSize: '0.9rem' }}>
                    Loading...
                </div>
            </div>
        );
    };


    //render page error
    const showPageError = () => {
        return (
            <div>
                Oops, there was a page load error: {pageErrors}
            </div>
        );
    }

    //render data error
    const showDataError = () => {
        return (
            <Row>
                Oops, there was a data load error: {dataErrors}
            </Row>
        );
    }

    ////render loading
    //const showLoading_BAK = () => {
    //    return (
    //        <div>
    //            <img src={spinnerIcon} alt="loading..." />
    //        </div>
    //    );
    //}

    //render table container
    const showTableContainer = () => {
        if (fileTypeCriteria.fileTypeId === "0") {
            return (
                <div>Select file type above...</div>
            );
        } else {
            return (
                <Card key={'table-' + fileTypeCriteria.fileTypeId} className="mb-4">
                    <Card.Header style={{ backgroundColor: '#333333', color: '#f1f1f1', padding: '12px 16px' }}>
                        {showInputCriteria()}
                    </Card.Header>
                    <Card.Body style={{ height: (screenHeight - 410).toString() + 'px', overflow: "auto", paddingTop: 0 }}>
                        {(() => {
                            switch (dataStatus) {
                                case 'loading':
                                    return showDataLoading()
                                case 'ready':
                                    return showData()
                                case 'error':
                                    return showDataError()
                                default:
                                    /*UNCOMMENT AFTER TESTING*/
                                        /*return <p></p> */
                                return showData()
                            }
                        })()}
                    </Card.Body>
                    <Card.Footer style={{ backgroundColor: '#f9fafb', color: '#1f2937', padding: '12px 16px' }}>
                        <Container fluid style={{ height: '40px' }} >
                            {(() => {
                                if (dataStatus == 'ready') {
                                    return <Row>
                                        <Col className="d-flex justify-content-end">
                                            <PaginationComponent
                                                itemsCount={rowCount}
                                                itemsPerPage={activeCriteria.takeCount}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                                pageClickHandler={handlePageClick}
                                                alwaysShown={true}
                                                itemStyle={{ ...paginationStyle }}
                                                activeItemStyle={{ ...activePaginationStyle }}
                                                itemEvents={{
                                                    onFocus: e => Object.assign(e.target.style, goldInputFocus),
                                                    onBlur: e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                }
                            })()}
                        </Container>
                    </Card.Footer>
                </Card>
            );
        }
    }

    //render input criteria
    const showInputCriteria = () => {
        const selectedOperator =
            operators?.find(o => String(o.id) === String(activeCriteria.operatorId));
        const operatorLabel = selectedOperator ? selectedOperator.companyName : "Select...";

        return (
            <Form onSubmit={submitForm}>
                <Row className="g-2 align-items-end">

                    {/* Operated Company */}
                    <Col xs={6} md={3}>
                        <Form.Group controlId="formOperator">
                            <Form.Label
                                style={formLabel}
                            >
                                Operated Company
                            </Form.Label>
                            <Dropdown
                                style={{ marginRight: 20 }}
                            >
                                <Dropdown.Toggle
                                    id="dd-operator"
                                    bsPrefix="form-select"
                                    variant="light"
                                    disabled={dataStatus === "loading"}
                                    size="sm"
                                    style={{ ...dropDownToggle }}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    {operatorLabel}
                                </Dropdown.Toggle>

                                <Dropdown.Menu style={{ ...dropDownMenu }}>
                                    {operators?.map((op, i) => (
                                        <Dropdown.Item
                                            key={op.id ?? i}
                                            onClick={() =>
                                                handleChange({
                                                    preventDefault: () => { },
                                                    target: { name: "operatorId", value: op.id }
                                                })
                                            }
                                        >
                                            {op.companyName}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Form.Group>
                    </Col>

                    {/* Date Range */}
                    {fileTypeCriteria.fileTypeId !== "4" ? (
                        <Col xs={12} md={4}>
                            <Form.Label style={formLabel}>Received</Form.Label>
                            <Stack direction="horizontal" gap={2}>
                                {/* From Month */}
                                <Form.Select
                                    size="sm"
                                    name="fromMonth"
                                    disabled={dataStatus === "loading"}
                                    value={activeCriteria.fromMonth}
                                    onChange={handleChange}
                                    style={inputSm}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    {months.map((m, i) => (
                                        <option key={m} value={i + 1}>{m}</option>
                                    ))}
                                </Form.Select>

                                {/* From Year */}
                                <Form.Select
                                    size="sm"
                                    name="fromYear"
                                    disabled={dataStatus === "loading"}
                                    value={activeCriteria.fromYear}
                                    onChange={handleChange}
                                    style={inputSm}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    {years.map((y) => (
                                        <option
                                            key={y}
                                            value={y}
                                        >
                                            {y}
                                        </option>
                                    ))}
                                </Form.Select>

                                <span style={{ fontSize: "12px" }}>-</span>

                                {/* To Month */}
                                <Form.Select
                                    size="sm"
                                    name="toMonth"
                                    disabled={dataStatus === "loading"}
                                    value={activeCriteria.toMonth}
                                    onChange={handleChange}
                                    style={inputSm}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    {months.map((m, i) => (
                                        <option key={m} value={i + 1}>{m}</option>
                                    ))}
                                </Form.Select>

                                {/* To Year */}
                                <Form.Select
                                    size="sm"
                                    name="toYear"
                                    disabled={dataStatus === "loading"}
                                    value={activeCriteria.toYear}
                                    onChange={handleChange}
                                    style={{ ...inputSm, marginRight: 20 }}
                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                >
                                    {years.map((y) => (
                                        <option key={y} value={y}>{y}</option>
                                    ))}
                                </Form.Select>
                            </Stack>
                        </Col>
                    ) : (
                        <>
                            {/* Year-only when fileTypeId === "4" */}
                            <Col xs={6} md={1}>
                                <Form.Group controlId="fromYear">
                                    <Form.Label style={formLabel}>From</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        name="fromYear"
                                        disabled={dataStatus === "loading"}
                                        value={activeCriteria.fromYear}
                                        onChange={handleChange}
                                        style={inputSm}
                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                    >
                                        {years.map((y) => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col xs={6} md={1}>
                                <Form.Group controlId="toYear">
                                    <Form.Label style={formLabel}>To</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        name="toYear"
                                        disabled={dataStatus === "loading"}
                                        value={activeCriteria.toYear}
                                        onChange={handleChange}
                                        style={inputSm}
                                        onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                        onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                    >
                                        {years.map((y) => (
                                            <option key={y} value={y}>{y}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </>
                    )}

                    {/* Status */}
                    <Col xs={6} md={2}>
                        <Form.Group controlId="formStatus">
                            <Form.Label style={{ ...formLabel, background: 'transparent' }}>Status</Form.Label>
                            <Form.Select
                                name="statusId"
                                size="sm"
                                aria-label="Status"
                                disabled={dataStatus === "loading"}
                                value={(activeCriteria.statusId) ?? 0}
                                onChange={handleChange}
                                style={inputSm}
                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                            >
                                {statusItems.map((status, i) => (
                                    <option key={i} value={i}>{status}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    {/* Search button */}
                    <Col xs={12} md={2} className="d-flex align-items-end gap-1">
                        {dataStatus === "loading" ? (
                            <Button
                                style={{ ...btnGold, marginRight: 3 }}
                                size="sm"
                                disabled
                            >
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </Button>
                        ) : (
                            <Button
                                style={
                                    hoveredBtn && hoveredBtn.type === "search"
                                        ? { ...btnGold, ...btnGoldHover, marginRight: 3, transition: "all .15s ease" }
                                        : { ...btnGold, marginRight: 3 }
                                }
                                onMouseEnter={() => setHoveredBtn({ type: "search" })}
                                onMouseLeave={() => setHoveredBtn(null)}
                                type="submit"
                                size="sm"
                                disabled={pageStatus === "loading"}
                                //onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                //onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                            >
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </Button>
                        )}
                    </Col>
                </Row>
            </Form>
        );
    };


    const showData = () => {
        if (fileTypeCriteria.fileTypeId === "1") {  //**************************REVENUE**************************
            return (
                <Container fluid style={{ padding: 0 }}>
                    <Row>
                        <div
                            style={{
                                maxoverflow: 'auto'
                            }}
                        >
                            <table className="table table-striped" aria-labelledby="tabelLabel" style={{ fontSize: '.85rem' }} >
                                <thead>
                                    <tr>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Co #
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Check Date
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Description
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Check Control Total
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Owner Count
                                        </th>
                                            {(() => {
                                                if (accountProfile.hasImpersonate) {
                                                    return (
                                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                                            Owner Utilized
                                                        </th>
                                                    );
                                                }
                                            })()}
                                        <th style={{ ...stickyThStyle, textAlign: "center", fontSize: 15, fontWeight: 900 }}>
                                            Non-Operated Statements
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Status
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900, cursor: 'pointer', userSelect: 'none' }} onClick={toggleStatusDateSort}>
                                            Status Date
                                            <FontAwesomeIcon
                                                icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                style={{ paddingLeft: 6, width: 8, height: 12 }}
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                {/*REMOVE AFER TESTING*/}
                                {/*<Button*/}
                                {/*    variant="primary"*/}
                                {/*    size="sm"*/}
                                {/*    onClick={() => navigate('/statements', {*/}
                                {/*        state: {*/}
                                {/*            dataFileId: 3,*/}
                                {/*            fileTypeId: fileTypeCriteria.fileTypeId*/}
                                {/*        }*/}
                                {/*    })}*/}
                                {/*>*/}
                                {/*    Get Statements*/}
                                {/*</Button>*/}
                                <tbody>
                                    {dataFiles.map((dataFile, i) => (
                                        <tr
                                            key={i}
                                            style={{
                                                fontSize: ".9rem",
                                                fontWeight: "500",
                                            }}
                                            onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                            onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                        >
                                            <td>{dataFile.companyNumber}</td>
                                            <td>{dataFile.checkDateString}</td>
                                            <td>{dataFile.description}</td>
                                            <td>{dataFile.checkControlTotalString}</td>
                                            <td>{dataFile.ownerCount}</td>
                                            {(() => {
                                                if (accountProfile.hasImpersonate) {
                                                    return (
                                                        <td>
                                                            <div>{dataFile.ownerUtilizedPercent}</div>
                                                            <ProgressBar
                                                                style={{ backgroundColor: "white" }}
                                                                className="progress-thin"
                                                                variant={(dataFile.ownerUtilizedPercent.replace("%", "") < 25 ? "danger"
                                                                    : dataFile.ownerUtilizedPercent.replace("%", "") < 50 ? "warning"
                                                                        : dataFile.ownerUtilizedPercent.replace("%", "") < 75 ? "info"
                                                                            : "success"
                                                                )}
                                                                now={dataFile.ownerUtilizedPercent.replace("%", "")}
                                                            />
                                                        </td>
                                                    );
                                                }
                                            })()}
                                            <td
                                                style={{ textAlign: "center" }}
                                            >
                                                <Button
                                                    style={{
                                                        ...btnGold
                                                    }}
                                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                    //onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                    //onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                    size="sm"
                                                    onClick={() => navigate('/statements', {
                                                        state: {
                                                            dataFileId: dataFile.id,
                                                            fileTypeId: fileTypeCriteria.fileTypeId
                                                        }
                                                    })}
                                                    disabled={dataFile.statusId == 1}
                                                >
                                                    Get Statements
                                                </Button>
                                            </td>
                                            {(() => {
                                                switch (dataFile.statusId) {
                                                    case 1:
                                                        return <td>File Load Processing</td>
                                                    case 2:
                                                        if (accountProfile.hasImpersonate) {
                                                            return <td style={{ textAlign: "left" }}>
                                                                <Button
                                                                    name="btnMap"
                                                                    style={{
                                                                        ...btnGold,
                                                                        background: "transparent",
                                                                        color: COLORS.gold,
                                                                        border: `2px dashed ${COLORS.gold}`,
                                                                        borderRadius: "10px",
                                                                        boxShadow: "none",
                                                                        fontWeight: 600,
                                                                        width: "100px",
                                                                    }}
                                                                    onMouseEnter={e => {
                                                                        e.target.style.color = COLORS.gold;
                                                                        e.target.style.borderStyle = "solid";
                                                                        e.target.style.borderColor = COLORS.gold;
                                                                    }}
                                                                    onMouseLeave={e => {
                                                                        e.target.style.transform = "translateY(-1px)";
                                                                        e.target.style.background = "transparent";
                                                                        e.target.style.color = COLORS.gold;
                                                                        e.target.style.borderStyle = "dashed";
                                                                        e.target.style.borderColor = COLORS.gold;
                                                                    }}
                                                                    size="sm"
                                                                    onClick={pageStatus === 'ready' ? (e) => handleMappingsButton(e, dataFile) : null}
                                                                >
                                                                    Click to Map
                                                                </Button>
                                                            </td>
                                                        } else {
                                                            return <td>Mapping Needed</td>
                                                        }
                                                    case 3:
                                                        return <td
                                                            style={{ textAlign: "left" }}
                                                        >
                                                            <Button
                                                                name="btnRelease"
                                                                style={{
                                                                    ...btnGold
                                                                }}
                                                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                                size="sm"
                                                                //onClick={(e) => handleStatusChange(e, dataFile.id, dataFile.statusId, i)}
                                                                onClick={() => {
                                                                    setPendingAction({
                                                                        id: dataFile.id,
                                                                        statusId: dataFile.statusId,
                                                                        index: i,
                                                                        dataFile
                                                                    });
                                                                    setClickToSendConfirmationModalShow(true);
                                                                }}
                                                            >
                                                                Click to Send
                                                            </Button>
                                                        </td>
                                                    case 4:
                                                        return <td>Sent</td>
                                                    default:
                                                        return
                                                }
                                            })()}
                                            <td>{dataFile.statusDateString}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Row>
                </Container>
            );
        } else if (fileTypeCriteria.fileTypeId === "2") {  //**************************JIB**************************
            return (
                <Container fluid style={{ padding: 0 }}>
                    <Row>
                        <div
                            style={{
                                maxoverflow: 'auto'
                            }}
                        >
                            <table className="table table-striped" aria-labelledby="tabelLabel" style={{ fontSize: '.85rem' }} >
                                <thead>
                                    <tr>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Co #
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Invoice Date
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Description
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            JIB Control Total
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Owner Count
                                        </th>
                                        {(() => {
                                            if (accountProfile.hasImpersonate) {
                                                return (
                                                    <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                                        Owner Utilized
                                                    </th>
                                                );
                                            }
                                        })()}
                                        <th style={{ ...stickyThStyle, textAlign: "center", fontSize: 15, fontWeight: 900 }}>
                                            Non-Operated Statements
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Status</th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900, cursor: 'pointer', userSelect: 'none' }} onClick={toggleStatusDateSort}>
                                            Status Date
                                            <FontAwesomeIcon
                                                icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                style={{ paddingLeft: 6, width: 8, height: 12 }}
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                {/*REMOVE AFER TESTING*/}
                                {/*<Button*/}
                                {/*    variant="primary"*/}
                                {/*    size="sm"*/}
                                {/*    onClick={() => navigate('/statements', {*/}
                                {/*        state: {*/}
                                {/*            dataFileId: 3,*/}
                                {/*            fileTypeId: fileTypeCriteria.fileTypeId*/}
                                {/*        }*/}
                                {/*    })}*/}
                                {/*>*/}
                                {/*    Get Statements*/}
                                {/*</Button>*/}
                                {/*<Button*/}
                                {/*    name="btnMap"*/}
                                {/*    variant="primary"*/}
                                {/*    size="sm"*/}
                                {/*    onClick={pageStatus === 'ready' ? (e) =>*/}
                                {/*        handleJIBMappingsButton(e) : null}*/}
                                {/*>*/}
                                {/*    Click to Map*/}
                                {/*</Button>*/}
                                <tbody>
                                    {dataFiles.map((dataFile, i) => (
                                        <tr
                                            key={i}
                                            style={{
                                                fontSize: ".9rem",
                                                fontWeight: "500",
                                            }}
                                            onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                            onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                        >
                                            <td>{dataFile.companyNumber}</td>
                                            <td>{dataFile.checkDateString}</td>
                                            <td style={{ fontWeight: "bold" }}>{dataFile.description}</td>
                                            <td>{dataFile.checkControlTotalString}</td>
                                            <td>{dataFile.ownerCount}</td>
                                            <td>
                                                {(() => {
                                                    if (accountProfile.hasImpersonate) {
                                                        return (
                                                            <td>
                                                                <div>{dataFile.ownerUtilizedPercent}</div>
                                                                <ProgressBar
                                                                    style={{ backgroundColor: "white" }}
                                                                    className="progress-thin"
                                                                    variant={(dataFile.ownerUtilizedPercent.replace("%", "") < 25 ? "danger"
                                                                        : dataFile.ownerUtilizedPercent.replace("%", "") < 50 ? "warning"
                                                                            : dataFile.ownerUtilizedPercent.replace("%", "") < 75 ? "info"
                                                                                : "success"
                                                                    )}
                                                                    now={dataFile.ownerUtilizedPercent.replace("%", "")}
                                                                />
                                                            </td>
                                                        );
                                                    }
                                                })()}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                                <Button
                                                    style={{
                                                        ...btnGold
                                                    }}
                                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                    size="sm"
                                                    onClick={() => navigate('/statements', {
                                                        state: {
                                                            dataFileId: dataFile.id,
                                                            fileTypeId: fileTypeCriteria.fileTypeId
                                                        }
                                                    })}
                                                    disabled={dataFile.statusId === 1}
                                                >
                                                    Get Statements
                                                </Button>
                                            </td>
                                            {(() => {
                                                switch (dataFile.statusId) {
                                                    case 1:
                                                        return <td>File Load Processing</td>
                                                    case 2:
                                                        if (accountProfile.hasImpersonate) {
                                                            return <td style={{ textAlign: "left" }}>
                                                                <Button
                                                                    name="btnMap"
                                                                    style={{
                                                                        ...btnGold,
                                                                        background: "transparent",
                                                                        color: COLORS.gold,
                                                                        border: `2px dashed ${COLORS.gold}`,
                                                                        borderRadius: "10px",
                                                                        boxShadow: "none",
                                                                        fontWeight: 600,
                                                                        width: "100px",
                                                                    }}
                                                                    onMouseEnter={e => {
                                                                        e.target.style.color = COLORS.gold;
                                                                        e.target.style.borderStyle = "solid";
                                                                        e.target.style.borderColor = COLORS.gold;
                                                                    }}
                                                                    onMouseLeave={e => {
                                                                        e.target.style.transform = "translateY(-1px)";
                                                                        e.target.style.background = "transparent";
                                                                        e.target.style.color = COLORS.gold;
                                                                        e.target.style.borderStyle = "dashed";
                                                                        e.target.style.borderColor = COLORS.gold;
                                                                    }}
                                                                    size="sm"
                                                                    onClick={pageStatus === 'ready' ? (e) =>
                                                                        handleJIBMappingsButton(e, dataFile) : null}
                                                                >
                                                                    Click to Map
                                                                </Button>
                                                            </td>
                                                        } else {
                                                            return <td>Mapping Needed</td>
                                                        }
                                                    case 3:
                                                        return <td
                                                            style={{ textAlign: "left" }}
                                                        >
                                                            <Button
                                                                name="btnRelease"
                                                                style={{
                                                                    ...btnGold,
                                                                }}
                                                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                                size="sm"
                                                                //onClick={(e) => handleStatusChange(e, dataFile.id, dataFile.statusId, i)}
                                                                onClick={() => {
                                                                    setPendingAction({
                                                                        id: dataFile.id,
                                                                        statusId: dataFile.statusId,
                                                                        index: i,
                                                                        dataFile
                                                                    });
                                                                    setClickToSendConfirmationModalShow(true);
                                                                }}
                                                            >
                                                            Click to Send
                                                        </Button>
                                                        </td>
                                                    case 4:
                                                        return <td>Sent</td>
                                                    default:
                                                        return
                                                }
                                            })()}
                                            <td>{dataFile.statusDateString}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Row>
                </Container>
            );
        } else if (fileTypeCriteria.fileTypeId === "4") {  //**************************1099**************************
            return (
                <Container fluid style={{ padding: 0 }}>
                    <Row>
                        <div
                            style={{
                                maxoverflow: 'auto'
                            }}
                        >
                            <table className="table table-striped" aria-labelledby="tabelLabel" style={{ fontSize: '.85rem' }} >
                                <thead>
                                    <tr>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Co #
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Tax Year
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Version
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Description
                                        </th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Owner Count
                                        </th>
                                        {(() => {
                                            if (accountProfile.hasImpersonate) {
                                                return (
                                                    <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                                        Owner Utilized
                                                    </th>
                                                );
                                            }
                                        })()}
                                        <th></th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900 }}>
                                            Status</th>
                                        <th style={{ ...stickyThStyle, fontSize: 15, fontWeight: 900, cursor: 'pointer', userSelect: 'none' }} onClick={toggleStatusDateSort}>
                                            Status Date
                                            <FontAwesomeIcon
                                                icon={sortDirection === 'Ascending' ? faArrowUpLong : faArrowDownLong}
                                                style={{ paddingLeft: 6, width: 8, height: 12 }}
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                {/*REMOVE AFER TESTING*/}
                                {/*<Button*/}
                                {/*    variant="primary"*/}
                                {/*    size="sm"*/}
                                {/*    onClick={() => navigate('/statements', {*/}
                                {/*        state: {*/}
                                {/*            dataFileId: 3,*/}
                                {/*            fileTypeId: fileTypeCriteria.fileTypeId*/}
                                {/*        }*/}
                                {/*    })}*/}
                                {/*>*/}
                                {/*    Get Statements*/}
                                {/*</Button>*/}
                                {/*<Button*/}
                                {/*    name="btnMap"*/}
                                {/*    variant="primary"*/}
                                {/*    size="sm"*/}
                                {/*    onClick={pageStatus === 'ready' ? (e) =>*/}
                                {/*        handleJIBMappingsButton(e) : null}*/}
                                {/*>*/}
                                {/*    Click to Map*/}
                                {/*</Button>*/}
                                <tbody>
                                    {dataFiles.map((dataFile, i) => (
                                        <tr
                                            key={i}
                                            style={{
                                                fontSize: ".9rem",
                                                fontWeight: "500",
                                            }}
                                            onMouseEnter={e => Object.assign(e.currentTarget.style, tableRowHover)}
                                            onMouseLeave={e => Object.assign(e.currentTarget.style, tableRowUnHover)}
                                        >
                                            <td>{dataFile.companyNumber}</td>
                                            <td>{yearFrom(dataFile.checkDateString)}</td>
                                            <td>{dataFile.ten99Version}</td>
                                            <td>{dataFile.description}</td>
                                            <td>{dataFile.ownerCount}</td>
                                            <td>
                                                {(() => {
                                                    if (accountProfile.hasImpersonate) {
                                                        return (
                                                            <td>
                                                                <div>{dataFile.ownerUtilizedPercent}</div>
                                                                <ProgressBar
                                                                    style={{ backgroundColor: "white" }}
                                                                    className="progress-thin"
                                                                    variant={(dataFile.ownerUtilizedPercent.replace("%", "") < 25 ? "danger"
                                                                        : dataFile.ownerUtilizedPercent.replace("%", "") < 50 ? "warning"
                                                                            : dataFile.ownerUtilizedPercent.replace("%", "") < 75 ? "info"
                                                                                : "success"
                                                                    )}
                                                                    now={dataFile.ownerUtilizedPercent.replace("%", "")}
                                                                />
                                                            </td>
                                                        );
                                                    }
                                                })()}
                                            </td>
                                            <td style={{ textAlign: "center" }}>
                                                <Button
                                                    style={{
                                                        ...btnGold
                                                    }}
                                                    onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                    onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                    onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                    onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                    size="sm"
                                                    onClick={() => navigate('/statements', {
                                                        state: {
                                                            dataFileId: dataFile.id,
                                                            fileTypeId: fileTypeCriteria.fileTypeId
                                                        }
                                                    })}
                                                    disabled={dataFile.statusId === 1}
                                                >
                                                    Get Statements
                                                </Button>
                                            </td>
                                            {(() => {
                                                switch (dataFile.statusId) {
                                                    case 1:
                                                        return <td>File Load Processing</td>
                                                    case 2:
                                                        if (accountProfile.hasImpersonate) {
                                                            return <td style={{ textAlign: "left" }}>
                                                                <Button
                                                                    name="btnMap"
                                                                    style={{
                                                                        ...btnGold,
                                                                        background: "transparent",
                                                                        color: COLORS.gold,
                                                                        border: `2px dashed ${COLORS.gold}`,
                                                                        borderRadius: "10px",
                                                                        boxShadow: "none",
                                                                        fontWeight: 600,
                                                                        width: "100px",
                                                                    }}
                                                                    onMouseEnter={e => {
                                                                        e.target.style.color = COLORS.gold;
                                                                        e.target.style.borderStyle = "solid";
                                                                        e.target.style.borderColor = COLORS.gold;
                                                                    }}
                                                                    onMouseLeave={e => {
                                                                        e.target.style.transform = "translateY(-1px)";
                                                                        e.target.style.background = "transparent";
                                                                        e.target.style.color = COLORS.gold;
                                                                        e.target.style.borderStyle = "dashed";
                                                                        e.target.style.borderColor = COLORS.gold;
                                                                    }}
                                                                    size="sm"
                                                                    onClick={pageStatus === 'ready' ? (e) =>
                                                                        handleTen99MappingsButton(e, dataFile) : null}
                                                                >
                                                                    Click to Map
                                                                </Button>
                                                            </td>
                                                        } else {
                                                            return <td>Mapping Needed</td>
                                                        }
                                                    case 3:
                                                        return <td
                                                            style={{ textAlign: "left" }}
                                                        >
                                                            <Button
                                                                name="btnRelease"
                                                                style={{
                                                                    ...btnGold,
                                                                }}
                                                                onMouseEnter={e => Object.assign(e.target.style, boxshadowHover)}
                                                                onMouseLeave={e => Object.assign(e.target.style, boxshadowUnHover(btnGold))}
                                                                onFocus={e => Object.assign(e.target.style, goldInputFocus)}
                                                                onBlur={e => Object.assign(e.target.style, { outline: "none", boxShadow: "none" })}
                                                                size="sm"
                                                                //onClick={(e) => handleStatusChange(e, dataFile.id, dataFile.statusId, i)}
                                                                onClick={() => {
                                                                    setPendingAction({
                                                                        id: dataFile.id,
                                                                        statusId: dataFile.statusId,
                                                                        index: i,
                                                                        dataFile
                                                                    });
                                                                    setClickToSendConfirmationModalShow(true);
                                                                }}
                                                            >
                                                            Click to Send
                                                        </Button>
                                                        </td>
                                                    case 4:
                                                        return <td>Sent</td>
                                                    default:
                                                        return
                                                }
                                            })()}
                                            <td>{dataFile.statusDateString}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Row>
                </Container>
            );
        }
    }

    //render component
    return (
        <>
            <Alert variant={alertVariant} show={alertShow} onClose={() => setAlertShow(false)} dismissible>
                {alertMessage}
            </Alert>
            <p style={{ fontSize: '1.75rem', fontWeight: '700', color: '#333333', marginTop: '8px', marginBottom: '4px', textAlign: 'center' }}>Operated Data Files</p>
            <div className="mb-3">
                <Nav
                    variant="tabs"
                    activeKey={fileTypeCriteria.fileTypeId}
                    onSelect={handleTabSelect}
                    style={{
                        borderBottom: `1px solid ${COLORS.gold}`
                    }}
                >
                    <Nav.Item>
                        <Nav.Link
                            eventKey="1"
                            style={{
                                width: '150px',
                                textAlign: 'center',
                                fontWeight: fileTypeCriteria.fileTypeId === '1' ? '600' : 'normal',
                                fontSize: fileTypeCriteria.fileTypeId === '1' ? '1.1rem' : '0.9rem',
                                letterSpacing: fileTypeCriteria.fileTypeId === '1' ? '0.4px' : '0',
                                borderColor: fileTypeCriteria.fileTypeId === '1'
                                    ? `${COLORS.gold} ${COLORS.gold} transparent`
                                    : undefined,
                                transform: fileTypeCriteria.fileTypeId === '1' ? 'translateY(0)' : 'translateY(' + 4 + 'px)',
                                color: fileTypeCriteria.fileTypeId === '1' ? '#333333' : '#6c757d',
                            }}
                        >
                            Revenue
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            eventKey="2"
                            disabled={!isJibEnabled}
                            style={{
                                width: '150px',
                                textAlign: 'center',
                                fontWeight: fileTypeCriteria.fileTypeId === '2' ? '600' : 'normal',
                                fontSize: fileTypeCriteria.fileTypeId === '2' ? '1.1rem' : '0.9rem',
                                letterSpacing: fileTypeCriteria.fileTypeId === '2' ? '0.4px' : '0',
                                borderColor: fileTypeCriteria.fileTypeId === '2'
                                    ? `${COLORS.gold} ${COLORS.gold} transparent`
                                    : undefined,
                                color: fileTypeCriteria.fileTypeId === '2' ? '#333333' : '#6c757d',
                                transform: fileTypeCriteria.fileTypeId === '2' ? 'translateY(0)' : 'translateY(' + 4 + 'px)'
                            }}
                        >
                            JIB
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            eventKey="4"
                            disabled={!is1099Enabled}
                            style={{
                                width: '150px',
                                textAlign: 'center',
                                fontWeight: fileTypeCriteria.fileTypeId === '4' ? '600' : 'normal',
                                fontSize: fileTypeCriteria.fileTypeId === '4' ? '1.1rem' : '0.9rem',
                                letterSpacing: fileTypeCriteria.fileTypeId === '4' ? '0.4px' : '0',
                                borderColor: fileTypeCriteria.fileTypeId === '4'
                                    ? `${COLORS.gold} ${COLORS.gold} transparent`
                                    : undefined,
                                color: fileTypeCriteria.fileTypeId === '4' ? '#333333' : '#6c757d',
                                transform: fileTypeCriteria.fileTypeId === '4' ? 'translateY(0)' : 'translateY(' + 4 + 'px)'
                            }}
                        >
                            1099
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>
            {/*{(() => {*/}
            {/*    switch (fileTypeCriteria.fileTypeId) {*/}
            {/*        case '0':*/}
            {/*            return <h3>Data Files</h3>*/}
            {/*        case '1':*/}
            {/*            return <h3>Check Data Files</h3>*/}
            {/*        case '2':*/}
            {/*            return <h3>JIB Data Files</h3>*/}
            {/*        case '3':*/}
            {/*            return <h3>1099 Data Files</h3>*/}
            {/*        default:*/}
            {/*            return <p></p>*/}
            {/*    }*/}
            {/*})()}*/}
            {(() => {
                switch (pageStatus) {
                    case 'loading':
                        return showPageLoading()
                    case 'ready':
                        if (displayResultGrid === true) {
                            return showTableContainer()
                        } else {
                            return <p></p>
                        }
                    case 'error':
                        return showPageError()
                    default:
                        return <p>No Page Loaded.</p>
                }
            })()}

            <MappingsModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                handlemapbutton={mappingButtonClick}
                datafile={selectedDataFile}
            />

            <JibMappingsModal
                show={jibMapModalShow}
                onHide={() => setJibMapModalShow(false)}
                handlemapbutton={mappingButtonClick}
                datafile={selectedDataFile}
            />

            <Ten99MappingsModal
                show={ten99MapModalShow}
                onHide={() => setTen99MapModalShow(false)}
                handlemapbutton={mappingButtonClick}
                datafile={selectedDataFile}
            />

            <ClickToSendConfirmationModal
                show={clickToSendConfirmationModalShow}
                onHide={() => setClickToSendConfirmationModalShow(false)}
                dataFile={pendingAction?.dataFile}
                fileTypeId={fileTypeCriteria.fileTypeId}
                onConfirm={() => {
                    handleStatusChange(pendingAction.id, pendingAction.statusId, pendingAction.index);
                    setClickToSendConfirmationModalShow(false);
                    setPendingAction(null);
                }}
            />
        </>
    );
}

export default DataFiles;
